import { useAppSelector } from 'shared/hooks/redux/hooks';
import { firmware_keys, } from 'entities/device.service.accessories.upgrade/model/type';
import { accessoriesFirmwareUpdate, isAccessoriesFirmwareDeclined, } from 'entities/device.service.accessories.upgrade/lib/accessories-firmware';
import { createSelector } from '@reduxjs/toolkit';
import { selectDevice, selectDevices } from 'entities/device/lib';
import { createSubsetSelector, removeNulls, selectStripItemsOfArray } from 'utils';
import { LegacyDevice } from 'console/device/device';
const getFirmwareDevice = createSelector((state, device_id) => selectDevice(state, device_id), 
// @ts-ignore need readonly
createSubsetSelector(firmware_keys));
export const getFirmwareDevices = createSelector(selectDevices, 
// @ts-ignore need readonly
selectStripItemsOfArray(firmware_keys));
export function useGetDeviceWithAccessoriesUpdateSuggestions() {
    const devices = useAppSelector(getFirmwareDevices);
    const { versions: last_firmwares, declines } = useAppSelector((state) => state.last_accessories_firmwares);
    const user_id = useAppSelector((state) => state.account.id);
    return removeNulls(devices.flatMap((dev) => {
        if ((dev.firmware_version?.[0] ?? -1) < 479) {
            return null;
        }
        if (!dev.online) {
            return null;
        }
        const io_ext_with_new_firmware = accessoriesFirmwareUpdate(user_id, last_firmwares, dev, undefined, true);
        if (io_ext_with_new_firmware.length === 0) {
            return null;
        }
        return io_ext_with_new_firmware.map((firmware) => {
            if (isAccessoriesFirmwareDeclined(dev.id, firmware, declines)) {
                return null;
            }
            return {
                device: {
                    device_id: dev.id,
                    name: LegacyDevice.display_name(dev),
                },
                accessor: {
                    id: firmware.item_id,
                    serial: firmware.serial,
                    hw: firmware.hw,
                    name: firmware.item_name,
                },
                version: {
                    current: firmware.fw_str,
                    last: firmware.firmware.version_str,
                    original: firmware.firmware.id,
                },
            };
        });
    }));
}
export function useHasAccessoriesFirmwareUpdate(device_id, io_ext_id) {
    const device = useAppSelector((state) => getFirmwareDevice(state, device_id));
    const { versions: last_firmwares } = useAppSelector((state) => state.last_accessories_firmwares);
    const user_id = useAppSelector((state) => state.account.id);
    if (device == null) {
        return false;
    }
    if ((device.firmware_version?.[0] ?? -1) < 479) {
        return false;
    }
    if (io_ext_id == null) {
        return false;
    }
    const io_ext_with_new_firmware = accessoriesFirmwareUpdate(user_id, last_firmwares, device, io_ext_id, false);
    return io_ext_with_new_firmware.length > 0;
}
